import api from '@/api';
import { PageResult } from '@/core/request/PageResult';
import { API_BASE_URL } from '..';
import {
  getInvoiceDocReferencedResponse,
  InvoiceDocReferencedPayload,
} from './referencedDocument.types';

const CONTROLLER_URL = `${API_BASE_URL}/invoices`;

export async function createReferencedDocument(
  obj: InvoiceDocReferencedPayload,
) {
  const { invoiceId, ...objRequest } = obj;

  const result = (await api.post(
    `${CONTROLLER_URL}/${invoiceId}/referencedDocuments`,
    objRequest,
    null,
  )) as unknown;

  return result as InvoiceDocReferencedPayload;
}

export async function listInvoiceDocReferenced(id: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${id}/referencedDocuments`,
    {},
  )) as unknown;

  return result as PageResult<getInvoiceDocReferencedResponse>;
}

export async function deleteInvoiceDocReferenced(
  invoiceId: number,
  id: number,
) {
  const result = await api.remove(
    `${CONTROLLER_URL}/${invoiceId}/referencedDocuments/${id}`,
    {},
    null,
  );

  return result;
}

export async function getInvoiceDocReferencedId(invoiceId: number, id: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${invoiceId}/referencedDocuments/${id}`,
    null,
  )) as unknown;
  return result as InvoiceDocReferencedPayload;
}

export async function updateInvoiceDocReferenced(
  obj: InvoiceDocReferencedPayload,
) {
  const { invoiceId, ...objRequest } = obj;

  const result = (await api.put(
    `${CONTROLLER_URL}/${invoiceId}/referencedDocuments`,
    objRequest,
    null,
  )) as unknown;
  return result as getInvoiceDocReferencedResponse;
}
